import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import { CiClock2 } from "react-icons/ci";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CopyRight from "../components/Student/Reusablecomponents/Copyright";
import ScenarioQuestionformat from "../components/Student/Reusablecomponents/ScenarioQuestionformat";
import Loading from "../components/Student/Reusablecomponents/Loading";
import InternetChecking from "../components/Student/Reusablecomponents/Network";
import { FaCaretRight, FaCaretLeft } from "react-icons/fa";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import { ANameData } from "../components/Redux/Reducers/Common/AssessmentName";
import WithTranslate from "../components/ReusableComponents/StaticTranslater/Translater";
import { useTranslation } from "react-i18next";
import notify from "../components/ReusableComponents/ToastifyAlerts";
import axiosInstance from "../components/ReusableComponents/Axios";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
import "./Assessts/Styles/PracticeAssessment.scss";
const PracticeAssessment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const SUBJectRef = useRef();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const AssessmentData = JSON.parse(localStorage.getItem("PAssessmentData"));
  const Logindetails = useSelector((state) => state.userDetailsData.LoginDetails);
  const [OpenModel, CLoseModel] = useState(false);
  const [SubjectData, setSubjectData] = useState();
  const [QNo, setQNo] = useState(0);
  const [visitedQuestions, setVisitedQuestions] = useState([]);
  const [UserSelectedAnswers, setUserSelectedAnswers] = useState([]);
  const [PresentExam, setPresentExam] = useState();
  const [GeTime, setGeTime] = useState();
  const [CNFModel, SetCNFModel] = useState(false);
  const [CNFsubmit, SetCNFsubmit] = useState(false);
  const [STModel, SetSTModel] = useState(false);
  const [Load, SetLoad] = useState(false);
  const [MAnswers, SetMAnswers] = useState([]);

  const [EditQuestion, SetEditQuestion] = useState(false);
  const [Units, SetUnits] = useState();
  const SubmitExam = () => {
    if (
      navigator.onLine &&
      Object.keys(UserSelectedAnswers).length > 0
    ) {
      CLoseModel(!OpenModel);
    }
  };

  const GetQuestionPaper = async () => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.get(`/PracticeTests/GetPracticeTestQuestions?SubjectId=${AssessmentData?.SubjectId}&Grade=${AssessmentData?.Grade}&TopicId=${AssessmentData?.TopicId}`);
      if (res.data?.[0]?.question && res.data.length >= 10) {
        setSubjectData(res.data);
      } else {
        navigate("/PracticeTest/TestSelection", { replace: true });
        notify("Test is not available for the selected topic, please select another Topic", "warning");
      }
      SetLoad((prev) => !prev);
    }
    catch (err) {
      console.log("err", err);
    }
  }
  useEffect(() => {
    if (AssessmentData?.SubjectId == 3) {
      GetEnglishQuestionpaper();
    } else {
      GetQuestionPaper();
    }

  }, []);
  const GetEnglishQuestionpaper = async () => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.get(`/PracticeTests/GetEnglishPracticeQuestions?Grade=${AssessmentData?.Grade}&MainReading=${AssessmentData?.MP || 0}&MainReadingPoem=${AssessmentData?.Poeam || 0}&BookId=${AssessmentData?.Book}&NonDetailedLesson=${AssessmentData?.Lesson || 0}&EngGrammar=${AssessmentData?.Grammer || 0}&SubjectId=3`);
      if (res.data?.[0]?.question && res.data.length >= 10) {
        setSubjectData(res.data);
      }
      else {
        navigate("/PracticeTest/TestSelection", { replace: true });
        notify("Test is not available for the selected Input, please select another Input", "warning");
      }
      SetLoad((prev) => !prev);
    }
    catch (err) {
      console.log("err", err);
    }
  }
  // Below function is to Save answers and move to next exam
  const saveAnswers = () => {
    setSubjectData();
    // localStorage.removeItem("ResumeId");
    CLoseModel(false);
    setUserSelectedAnswers([]);
    setVisitedQuestions([]);
    setQNo(0);
  };

  // Below function is for visitted questions
  const seenQuestions = async (e) => {
    if (!visitedQuestions.includes(e)) {
      setVisitedQuestions([...visitedQuestions, e]);
    }
  };
  const handleAnswerChange = async (
    e,
    correctanswer,
    Studentanswer,
    Sunits
  ) => {
    const name = e?.target?.name || e;
    // const { name, value } = e.target;
    if (
      name in UserSelectedAnswers &&
      UserSelectedAnswers[name] === Studentanswer &&
      SubjectData?.[QNo]?.questionType === "M"
    ) {
      delete UserSelectedAnswers[name];
      Studentanswer = "";
    } else {
      if (
        // GeTime > ExamHoldtime() &&
        Object.keys(UserSelectedAnswers).length === SubjectData.length - 1
      ) {
        SetSTModel(true);
      }
      setUserSelectedAnswers({
        ...UserSelectedAnswers,
        [name]: {
          StudentAnswer: SubjectData?.[QNo]?.answerValType === "M"
            ? Studentanswer?.filter((str) => str !== "")?.join(",")
            : SubjectData?.[QNo]?.answerType === "U"
              ? [Studentanswer, Sunits || Units]
              : Studentanswer,
          Answer: Studentanswer === correctanswer ? 1 : 0,
        }
      });
    }

  };
  const MAhandleChange = (index, e) => {
    const newInputs = [...MAnswers];
    switch (SubjectData?.[QNo]?.answerType) {
      case "T":
        const CONVERT = e.target.value
          .replace(/[^a-zA-Z0-9]/g, "")
          .slice(0, 30);
        newInputs[index] = CONVERT;
        break;
      case "F":
        const CONVER = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 3);
        newInputs[index] = CONVER;
        break;
      default:
        const Number = e.target.value.replace(/[^0-9.]/g, "").slice(0, 10);
        newInputs[index] = Number;
        break;
    }
    SetMAnswers(newInputs);
  };
  const BackgroundBG = () => {
    switch (SubjectData?.[QNo]?.subjectName) {
      case "English":
        return "EnglishBGAswersheet";
      case "Mathematics":
        return "MathsBGAswersheet";
      case "Biology":
        return "BiologyBGAswersheet";
      default:
        return "ScienceBGAswersheet";
    }
  };
  const [INQ, SetINQ] = useState();
  const SelecType = () => {
    switch (SubjectData?.[QNo]?.answerType) {
      case "T":
        return "text";
      case "F":
        return "text";
      default:
        return "number";
    }
  };
  const StoreINQAnswer = (e) => {
    switch (SubjectData?.[QNo]?.answerType) {
      case "T":
        const CONVERT = e.target.value
          .replace(/[^a-zA-Z0-9]/g, "")
          .slice(0, 30);
        SetINQ(CONVERT);
        break;
      case "F":
        const CONVER = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 3);
        SetINQ(CONVER);
        break;
      default:
        const Number = e.target.value.replace(/[^0-9.]/g, "").slice(0, 10);
        SetINQ(Number.trim());
        break;
    }
  };
  useMemo(() => {
    if (SubjectData?.[QNo]?.questionType === "D") {
      if (SubjectData?.[QNo]?.answerValType !== "M") {
        SetINQ(
          SubjectData?.[QNo]?.answerType === "U"
            ? UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId]?.[0] || ""
            : UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId] || ""
        );
        SetMAnswers([""]);
        if (SubjectData?.[QNo]?.actualUnitId > 0) {
          SetUnits(
            UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId]?.[1] || ""
          );
        }
      } else {
        SetMAnswers(
          UserSelectedAnswers?.[SubjectData?.[QNo]?.questionId]?.split(",") || [
            "",
            "",
            "",
            "",
            "",
          ]
        );
        SetINQ("");
        SetUnits("");
      }
    }
  }, [QNo, SubjectData]);
  // Below is answer all questions in multiple
  const [OpenMAlert, CloseMAlert] = useState(false);
  // Above is answer all questions in multiple
  const UnitAnswerStore = (e, Sunits) => {
    const value = e?.target?.value || INQ;
    const STunits = Units || Sunits;
    if (value > 0) {
      if (SubjectData?.[QNo]?.answerType === "U" && STunits) {
        handleAnswerChange(
          SubjectData?.[QNo]?.questionId,
          SubjectData?.[QNo]?.answer,
          value,
          Sunits
        );
      } else {
        notify("Please select units", "warning");
      }
    }
  };

  const NavigateResults = async () => {
    SetLoad((prev) => !prev);
    
    try {
      const PAssesssmentData = {
        "email": Logindetails?.LoginId,
        "userName": Logindetails?.Name,
        "grade": AssessmentData?.Grade.toString(),
        "subject": AssessmentData?.SubjectId.toString(),
        "topic": AssessmentData?.TopicId.toString(),
        book: AssessmentData?.Book,
        mainReading: AssessmentData?.MP,
        mainReadingPoem: AssessmentData?.Poeam,
        nonDetailedLesson: AssessmentData?.Lesson,
        engGrammar: AssessmentData?.Grammer,
        "noOfQuestions": SubjectData?.length,
        "questionsAttempted": Object.keys(UserSelectedAnswers)?.length,
        "correctAnswers": Object?.keys(UserSelectedAnswers)?.filter((key) => UserSelectedAnswers[key].Answer === 1).length,
      }
      const res = await axiosInstance.post("/PracticeTests/InsertPracticeTestSubmission", PAssesssmentData);
      SetLoad((prev) => !prev);
      navigate("/PracticeTest/PracticeResults", {
        state: {
          TQuestions: SubjectData?.length, CQuestions: Object?.keys(UserSelectedAnswers)?.filter((key) => UserSelectedAnswers[key].Answer === 1).length,
          IQuestions: Object?.keys(UserSelectedAnswers)?.filter((key) => UserSelectedAnswers[key].Answer === 0).length,
          UnAttempted:SubjectData?.length - Object.keys(UserSelectedAnswers)?.length, 
        },
      });
    }
    catch (err) {
      SetLoad((prev) => !prev);
      console.log(err)
    }

  }
  return (<>
    <div className="dflex gap-3 flexd-column p-4">
      <div className="Card">
        <div className="dflex JSBetween alignitems PTQDetails">
          <div >Question {QNo + 1} of {SubjectData?.length} <span>{AssessmentData?.SubjectName}<FaArrowRight/>{SubjectData && SubjectData?.[QNo]?.bookName ||
  SubjectData?.[QNo]?.grammarVal ||
  SubjectData?.[QNo]?.topicName}</span></div>
          {/* <button onClick={() => SubmitExam()}>End Test</button> */}
        </div>
        <div className="progress-container mt-3" >
          <div className="progress-fill" style={{ width: `${((Object.keys(UserSelectedAnswers)?.length) / SubjectData?.length) * 100}%` }} >
          </div>
        </div>
      </div>
      <div className="Card">
        <div className="Questions dflex flexd-column">
          {SubjectData && SubjectData[QNo].scenario && (
            <span>
              <b> Scenario:</b>{" "}
              <ScenarioQuestionformat
                scenario={SubjectData && SubjectData[QNo].scenario}
              />
            </span>
          )}

          <span className="dflex">
            <b style={{ textWrap: "nowrap" }}>
              Question {QNo + 1}:
            </b>{" "}
            <ScenarioQuestionformat
              scenario={SubjectData && SubjectData[QNo].question}
            />
          </span>
        </div>
        <div className="dflex gap-3 flexd-column">
          {
            ["A", "B", "C", "D"].map((option, index) => (
              <>
                {SubjectData?.[QNo]?.[`option${option}`] && (
                  <div
                    className={`${SubjectData && UserSelectedAnswers[SubjectData[QNo]?.questionId]?.StudentAnswer === option ? "IPTChecked-Question-Options" : ""} IPTQuestion-Options dflex`}
                    onClick={(e) => { handleAnswerChange(SubjectData[QNo]?.questionId, SubjectData[QNo]?.answer, option); }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleAnswerChange(SubjectData[QNo]?.questionId, SubjectData[QNo]?.answer, option);
                      }
                    }}
                  >
                    <span className="dflex" >
                      <p className="IPToptionName">{option}</p>
                      <ScenarioQuestionformat
                        scenario={
                          SubjectData &&
                          SubjectData[QNo]?.[`option${option}`]
                        }
                      />
                    </span>
                  </div>
                )}{" "}
              </>
            ))}
        </div>

      </div>
      <div className=" dflex JSBetween">
        <div></div>
        <div className="dflex gap-3 IPTNavigation_buttons" >
          <button disabled={QNo === 0}
            style={QNo === 0 ? { display: "none" } : {}}
            onClick={() => {
              if (navigator.onLine) {
                seenQuestions(SubjectData[QNo - 1].questionId);
                setQNo(QNo - 1);
              }
            }}>Previous</button>
          {SubjectData && QNo !== SubjectData.length - 1 &&
            <button
              disabled={SubjectData && QNo === SubjectData.length - 1}

              onClick={() => {
                if (
                  (MAnswers.filter((str) => str !== "").length >= 1 &&
                    SubjectData?.[QNo]?.answerValType === "M" &&
                    SubjectData?.[QNo]?.answer?.split(",").length !==
                    MAnswers.filter((str) => str !== "").length) ||
                  (SubjectData?.[QNo]?.answerType === "U" &&
                    !Units &&
                    INQ)
                ) {
                  CloseMAlert(!OpenMAlert);
                } else {
                  if (navigator.onLine) {
                    seenQuestions(SubjectData[QNo + 1].questionId);
                    setQNo(QNo + 1);
                  }
                }
              }}
            >Save & Next</button>
          }
           <button className="Buttons bg-danger" style={{color:"#FFF",border:"none"}} onClick={() => SubmitExam()}>End Test</button>
        </div>
      </div>
    </div>

    {OpenModel && (
      <div className="Model-Open">
        <div className="Card w-50 Model-Content dflex flexd-column JCCenter alignitems" >
          <div style={{ color: "#101828", fontSize: "25px", fontWeight: "600" }}>Are you sure you want to submit the Test?</div>
          <div className=" dflex gap-3 mt-3 IPTNavigation_buttons">
            <button className="Buttons bg-danger" style={{color:"#FFF",border:"none"}} onClick={() => CLoseModel(!OpenModel)}>Cancel</button>
            <button className="" onClick={() => NavigateResults()}>Submit Test</button>
          </div>
        </div></div>
    )}
    {Load && <Loading />}
  </>);
};
export default PracticeAssessment;
